import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white todays-course-box"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-25 p-15 ps-lg-25 pe-lg-25 border-bottom border-2"
}
const _hoisted_5 = { class: "fw-medium text-white mb-0" }
const _hoisted_6 = {
  key: 1,
  class: "mb-25 card border-0 shadow z-1 rounded-0 bg-white p-15 p-sm-25 ps-lg-25 pe-lg-25 fw-bold fs-12 text-muted"
}
const _hoisted_7 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_8 = {
  key: 1,
  class: "mb-15"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_SurveyCard = _resolveComponent("SurveyCard")!

  return (_ctx.surveys === undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SpinnerLoading, { class: "h-auto" })
        ])
      ]))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.survey_groups, (surveys, name, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row",
          key: `group:${name}`
        }, [
          (name !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.env === 'kareena')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.titlecase(name.toString())), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.titlecase(name.toString())), 1 /* TEXT */)
                    ]))
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveys, (survey) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 mb-25",
              key: survey.id
            }, [
              _createVNode(_component_SurveyCard, {
                survey: survey,
                patient_id: _ctx.patient.id!,
                onPriority: _ctx.checkSurveyPriority
              }, null, 8 /* PROPS */, ["survey", "patient_id", "onPriority"])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (index !== Object.keys(_ctx.survey_groups).length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
}